require("../../node_modules/jquery-validation/dist/jquery.validate.js");

module.exports = {
  init: () => {
    $.extend($.validator.messages, {
      required: "Dette felt er påkrævet",
      email: "Indtast venligst en gyldig email",
    });

    $("#newsletter-subscribe").on("submit", function (e) {
      if (!$(this).valid()) {
        e.preventDefault();
      }
    });

    $("#newsletterteaser-subscribe").on("submit", function (e) {
      if (!$(this).valid()) {
        e.preventDefault();
      }
    });
  },
};
